module.exports = __webpack_public_path__ + "img/23.ee255d2b.jpg";